module.exports = __webpack_public_path__ + "img/11.978e6d55.svg";